import { Directive, HostBinding, HostListener, Input, OnChanges } from '@angular/core';
import { DomSanitizer, SafeStyle, SafeUrl } from '@angular/platform-browser';

import { ImagePathUtil } from '../utils';


/**
 * ALL IMAGES ARE MOVED TO:
 * TST: 
 * - One slice: https://tstccms001.bfm.com/iw-cc/command/iw.ui?vpath=//tstccms001/default/main/BlackRock/One/WORKAREA/shared/images/tools-assets
 * - Intermediaries slice: https://tstccms001.bfm.com/iw-cc/command/iw.ui?vpath=//tstccms001/default/main/BlackRock/Intermediaries/WORKAREA/shared/images/tools-assets
 * 
 * BLK: 
 * - One slice: https://teamsite.bfm.com/iw-cc/command/iw.ui?vpath=//blkccms001/default/main/BlackRock/One/WORKAREA/shared/images/tools-assets
 * - Intermediaries slice: https://teamsite.bfm.com/iw-cc/command/iw.ui?vpath=//blkccms001/default/main/BlackRock/Intermediaries/WORKAREA/shared/images/tools-assets
 * 
 * If you want to add a new image, check if your image first exists in the directory. 
 * Upload the file to both TST and Prod BEFORE the release.
 */
@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: 'img[remote-src], [bg-image], [bg-image-hover]'
})
export class RemoteImageDirective implements OnChanges {
	// eslint-disable-next-line @angular-eslint/no-input-rename
	@Input('remote-src') public remoteSrc = '';
	@Input('bg-image') public bgImage = '';
	@Input('bg-image-hover') public bgImageHover = '';

	@HostBinding('src') public hostSrc: SafeUrl;
	@HostBinding('style.backgroundImage') public hostBackgroundImage: SafeStyle;

	constructor(
		private sanitizer: DomSanitizer
	) { }

	public ngOnChanges(): void {
		if (this.remoteSrc) {
			const imagePath = ImagePathUtil.getImagePath(this.remoteSrc);
			this.hostSrc = this.sanitizer.bypassSecurityTrustUrl(imagePath);
		}
		if (this.bgImage) {
			const imagePath = ImagePathUtil.getImagePath(this.bgImage);
			this.hostBackgroundImage = this.sanitizer.bypassSecurityTrustStyle(`url('${imagePath}')`);
		}
	}

	@HostListener('mouseenter')
	public onMouseEnter(): void {
		if (this.bgImageHover) {
			const imagePath = ImagePathUtil.getImagePath(this.bgImageHover);
			this.hostBackgroundImage = this.sanitizer.bypassSecurityTrustStyle(`url('${imagePath}')`);
		}
	}

	@HostListener('mouseleave')
	public onMouseLeave(): void {
		if (this.bgImage) {
			const imagePath = ImagePathUtil.getImagePath(this.bgImage);
			this.hostBackgroundImage = this.sanitizer.bypassSecurityTrustStyle(`url('${imagePath}')`);
		}
	}

}
